import React, {useEffect, useState} from "react";
import Layout from "../components/common/Layout";
import UserProfile from "../components/dashboard/UserProfile";
import {useAuth} from "../components/context/auth"
import api from '../components/settings/api'
import { useRouter } from 'next/router';
import crypto from 'crypto';

const Profile = () => {
  const { getUser } = useAuth();
  const [redirectNew, setRedirectNew] = useState(false)
  const [redirect, setRedirect] = useState(false)
  const router = useRouter();
  useEffect(() => {
    let asyncFunc = async () => {
      // Get the token from the URL
      const encryptedToken = new URLSearchParams(window.location.search).get('token');
      let newUser = new URLSearchParams(window.location.search).get('newUser');
      let key = new URLSearchParams(window.location.search).get('platform');
      const algorithm = 'aes-256-cbc';

      // Define a function to decrypt the token
      function decrypt(encryptedText) {
        try {
          const decipher = crypto.createDecipher(algorithm, key);
          let decrypted = decipher.update(encryptedText, 'hex', 'utf-8');
          decrypted += decipher.final('utf-8');
          return decrypted;
        } catch (error) {
          console.error('Decryption Error:', error);
          return null; // Return null or handle the error appropriately
        }
      }

      // Decrypt the token
      let token = decrypt(encryptedToken);
      newUser = newUser === 'true';

      if (token) {
        // Make an API request with the decrypted token
        api.get('/api/v1/users/social/verify', {
          params: { token }, // Pass the token as a query parameter
        }).then((res) => {
          // localStorage.setItem('token', res.data.data.token); <----deleting this as this will persist after user session
          // document.cookie = `token=${res.data.data.token}; path=/; domain=${window.location.hostname}; Secure; SameSite=None;`;
          if (newUser) {
            // Redirect to /thankyou if it's a new user
            getUser(res.data.data.token)
            router.replace('/thankyou');
            // setRedirectNew(false)
          } else {
            // Redirect to /profile if it's not a new user
            getUser(res.data.data.token)
            router.replace('/profile');
          }
        }).catch(() => {
          alert('Please log in')
          router.replace('/');
        })
      }
    };
    asyncFunc();
  }, []); // Run this effect only once when the component mounts



  return (
<></>
  );
};

export default Profile;
